<div class="container-fluid cw-background manage-view">
  <div class="row">
    <div class="col-12">
      <mat-card *ngIf="location" class="mat-elevation-z8 my-3">
        <div class="text-left go-back d-block">
          <button (click)="onGoBack()" disableRipple mat-button class="delete-user p-0">
            <mat-icon matPreffix>arrow_back_ios</mat-icon>
            Go Back
          </button>
          <h6 class="card-title-page mb-4">Edit Location:</h6>
        </div>
        <div class="row d-flex">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <app-dynamic-form
              *ngIf="questions"
              [questions]="questions"
              [disabled]="!isEdit"
              (formSubmit)="onUpdateLocation($event)"
              (hasChanged)="onChangeLocation($event)"
            >
            </app-dynamic-form>
            <button
              *ngIf="canEditLocation()"
              (click)="onToggleManageLocation()"
              class="edit"
              color="primary"
              mat-icon-button
            >
              <mat-icon>create</mat-icon><span class="mat-h3"> Edit</span>
            </button>
          </div>
        </div>
        <div class="row d-flex delete-btn">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <button *ngIf="canDeleteLocation()" (click)="onDeleteLocation()" disableRipple mat-button>
              <mat-icon matPreffix>delete</mat-icon>
              Delete location
            </button>
          </div>
        </div>
        <div class="container-fluid cw-background">
          <div class="row">
            <div class="col-12">
              <mat-tab-group [@.disabled]="true" (selectedTabChange)="onTabChange()">
                <mat-tab label="Assets">
                  <app-data-table
                    *ngIf="assetsTableConfig"
                    [config]="assetsTableConfig"
                    (getData)="getAssets($event)"
                    (updateData)="assetTableService.updateAsset($event)"
                  ></app-data-table>
                </mat-tab>
                <mat-tab label="Users">
                  <app-data-table
                    *ngIf="usersTableConfig"
                    [config]="usersTableConfig"
                    (getData)="getUsers($event)"
                    (updateData)="userTableService.update($event)"
                  ></app-data-table>
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
